export interface MockUser {
  id: string;
  email: string;
  password: string;
  name: string;
  role: 'admin' | 'manager';
}

export const mockUsers: MockUser[] = [
  {
    id: '11111111-1111-1111-1111-111111111111',
    email: 'admin@company.com',
    password: 'admin123',
    name: 'Admin User',
    role: 'admin',
  },
  {
    id: '44444444-4444-4444-4444-444444444444',
    email: 'sarah.admin@company.com',
    password: 'admin123',
    name: 'Sarah Johnson',
    role: 'admin',
  },
  {
    id: '55555555-5555-5555-5555-555555555555',
    email: 'sdhawan@autonomize.ai',
    password: 'admin123',
    name: 'Sahil Dhawan',
    role: 'admin',
  },
  {
    id: '66666666-6666-6666-6666-666666666666',
    email: 'kris@autonomize.ai',
    password: 'admin123',
    name: 'Kris Nair',
    role: 'admin',
  },
  {
    id: '77777777-5555-5555-5555-555555555555',
    email: 'sankumar@ex2india.com',
    password: 'admin123',
    name: 'Sankalp Kumar',
    role: 'admin',
  },
  {
    id: '11111111-5555-5555-8888-555555555555',
    email: 'hkumar@ex2india.com',
    password: 'admin123',
    name: 'Hemant Bhagat',
    role: 'admin',
  },
  {
    id: '693123ffe4e2a41f3f4d8e14',
    email: 'john@autonomize.ai',
    name: 'John Smith',
    password: 'manager123',
    role: 'manager'
  },
  {
    id: '6931247be4e2a41f3f4d8e15',
    email: 'charles@autonomize.ai',
    name: 'Charles',
    password: 'manager123',
    role: 'manager'
  },
  {
    id: '693124a7e4e2a41f3f4d8e16',
    email: 'robert@autonomize.ai',
    name: 'Robert',
    password: 'manager123',
    role: 'manager'
  },
  {
    id: '693124bde4e2a41f3f4d8e17',
    email: 'angila@autonomize.ai',
    name: 'Angila',
    password: 'manager123',
    role: 'manager'
  },
  {
    id: '693124d2e4e2a41f3f4d8e18',
    email: 'jonnny@autonomize.ai',
    name: 'Jonny',
    password: 'manager123',
    role: 'manager'
  },
  {
    id: '69312500e4e2a41f3f4d8e19',
    email: 'smith@autonomize.ai',
    name: 'smith',
    password: 'manager123',
    role: 'manager'
  }
];

export function authenticateUser(email: string, password: string): MockUser | null {
  const user = mockUsers.find(
    (u) => u.email.toLowerCase() === email.toLowerCase() && u.password === password
  );
  return user || null;
}
